import { IChatOfflinePushInfo, ICallOfflinePushInfo } from './interface';

export const chatOfflinePushInfo: IChatOfflinePushInfo = {
  androidInfo: {},
  apnsInfo: {},
};

export const callOfflinePushInfo: ICallOfflinePushInfo = {};
